import { gql } from '@apollo/client';

export const RawDraftContentStateFragmentAST = gql`
  fragment RawDraftContentStateFragment on DraftJS_ContentState {
    blocks {
      key
      text
      type
      depth
      inlineStyleRanges {
        offset
        length
        style
        __typename
      }
      entityRanges {
        offset
        length
        key
        __typename
      }
    }
    entityMap {
      type
      mutability
      data {
        ... on DraftJS_ContentState_Entity_Data_LinkData {
          explicit
          url
          targetOption
          hideLinkPreview
          __typename
        }
        ... on DraftJS_ContentState_Entity_Data_MentionData {
          mention {
            userId
            user {
              displayName
              __typename
            }
            userCanView
            __typename
          }
          __typename
        }
        ... on DraftJS_ContentState_Entity_Data_ImageData {
          src
          alt
          height
          width
          alignment
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
`;
